import { render, staticRenderFns } from "./NewItemForm.vue?vue&type=template&id=6f4b5d6f&scoped=true&"
import script from "./NewItemForm.vue?vue&type=script&lang=js&"
export * from "./NewItemForm.vue?vue&type=script&lang=js&"
import style0 from "./NewItemForm.vue?vue&type=style&index=0&id=6f4b5d6f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f4b5d6f",
  null
  
)

export default component.exports